<template>
  <div>
    <BlocoFiltroPesquisa
      nome-do-form="DocumentoForm"
      :ordenar-nomes="['Nome', 'Tipo']"
      :ordenar-por="['documento.nome', 'documento.tipo.valor']"
      @pesquisar="pesquisar"
      @ordenar="ordenar"
      @novo="novo"
    >
      <template #form>
        <div class="row">
          <div class="col-xs-6 col-sm-2 col-md-2 col-lg-2">
            <label for="regra">Tipo Envio</label>
            <select
              v-model="tipoEnvio"
              data-test-id="select-tipoenvio"
              class="form-control"
              @change="tipoEnvioSelecionado"
            >
              <option value="paciente"> Paciente </option>
              <option value="profissional"> Profissional </option>
            </select>
          </div>
          <div
            v-show="tipoEnvio === 'paciente'"
            class="col-xs-12 col-sm-8 col-md-6 col-lg-6"
          >
            <BuscarSelecionarPaciente
              :minimo="1"
              label="Paciente"
              @selecionadoPaciente="pacienteId = $event._id"
              @limparPaciente="limparPaciente"
            />
          </div>
          <div
            v-show="tipoEnvio === 'profissional'"
            class="col-xs-12 col-sm-8 col-md-6 col-lg-6"
          >
            <BuscarSelecionarProfissional
              :minimo="1"
              label="Profissional"
              @selecionadoProfissional="profissionalId = $event._id"
              @limparProfissional="limparProfissional"
            />
          </div>
        </div>
      </template>
    </BlocoFiltroPesquisa>
    <DocumentoTabela
      v-if="documentos && documentos.length > 0"
      :documentos="documentos"
    />
  </div>
</template>

<script>
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import BlocoFiltroPesquisa from '@/componentes/formulario/BlocoFiltroPesquisa'
import BuscarSelecionarPaciente from '@/componentes/formulario/BuscarSelecionarPaciente'
import BuscarSelecionarProfissional from '@/componentes/formulario/BuscarSelecionarProfissional'
import { useMenu } from '@/composables/useMenu'
import { usePesquisa } from '@/composables/usePesquisa'
import PacienteServico from '@/servicos/PacienteServico'
import ProfissionalServico from '@/servicos/ProfissionalServico'
import appStore from '@/stores'

import DocumentoTabela from './DocumentoTabela'

const pacienteServico = new PacienteServico()
const profissionalServico = new ProfissionalServico()

export default {
  components: {
    DocumentoTabela,
    BlocoFiltroPesquisa,
    BuscarSelecionarPaciente,
    BuscarSelecionarProfissional,
  },
  setup() {
    const router = useRouter()
    const route = useRoute()
    const servico = null
    const nomeResultado = 'documentos'
    const filtro = ref({})
    const pacienteId = ref('')
    const profissionalId = ref('')
    const tipoEnvio = ref('paciente')
    const documentos = ref([])
    const pesquisa = usePesquisa({
      filtro,
      resultado: documentos,
      servico,
      nomeResultado,
      onPesquisar: () => {
        if (tipoEnvio.value === 'paciente' && pacienteId.value !== '') {
          return pacienteServico
            .retornarDocumentos(pacienteId.value)
            .then((resposta) => {
              documentos.value = resposta.documentos
            })
        }

        if (tipoEnvio.value === 'profissional' && profissionalId.value !== '') {
          return profissionalServico
            .retornarDocumentos(profissionalId.value)
            .then((resposta) => {
              documentos.value = resposta.documentos
            })
        }

        documentos.value = []
        return null
      },
      onNovo: () => router.replace({ path: route.path + '/cadastro' }),
    })
    useMenu(63)
    return {
      filtro,
      pacienteId,
      profissionalId,
      tipoEnvio,
      documentos,
      ...pesquisa,
    }
  },

  computed: {
    usuario() {
      return appStore.usuario
    },
  },
  methods: {
    tipoEnvioSelecionado(event) {
      const tipoEnvio = event.target.value
      if (tipoEnvio === 'paciente') {
        this.profissionalId = ''
        this.documentos = []
      } else {
        this.pacienteId = ''
        this.documentos = []
      }
    },
    limparPaciente() {
      this.pacienteId = ''
      this.documentos = []
    },
    limparProfissional() {
      this.profissionalId = ''
      this.documentos = []
    },
  },
}
</script>
